export default {
  badge: 'Test',
  badge_title: 'Testrestaurant',
  notice: 'Das ist ein Testrestaurant. Bestellungen hier dienen nur zum Testen.',
};
